module.exports = __webpack_public_path__ + "static/media/equiliberty-logo.70031c3b.png";